<template>
  <div class="circle-btn">
    <slot>按钮</slot>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.circle-btn {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border-radius: 50%;
  background: linear-gradient(180deg, #4a86f6, #4465f3);
  color: #fff;
}
</style>
